export const Title = ({ label, variant }) => {
  const Heading = `h${variant}`;

  return (
  <Heading className="text-white text-2xl font-medium leading-tight text-primary inline-block align-middle">
    {variant === 1 && <span className="mr-4">&#9733;</span>}
    {label}
  </Heading>
)};
